<template>
  <div class="modal-card glass-modal" style="width: auto; max-width: 850px;">
    <header class="modal-card-head glass-header">
      <p class="modal-card-title has-text-white">{{ restaurante.id ? 'Editar Restaurante' : 'Nuevo Restaurante' }}</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body glass-body">
      <div class="columns is-multiline">
        <div class="column is-half">
          <b-field label="Nombre" custom-class="has-text-grey-light" class="glass-field">
            <b-input v-model="restaurante.nombre" placeholder="Nombre comercial" class="is-rounded" />
          </b-field>
        </div>

        <div class="column is-half">
          <b-field label="Evento Vinculado" custom-class="has-text-grey-light" class="glass-field">
            <b-select v-model="restaurante.evento_id" expanded class="is-rounded">
              <option :value="null">Ninguno / General</option>
              <optgroup label="Selecciona un evento">
                <option v-for="ev in eventos" :key="ev.id" :value="ev.id">
                  {{ ev.nombre }} {{ ev.activo == 1 ? '(Activo)' : '' }}
                </option>
              </optgroup>
            </b-select>
          </b-field>
        </div>

        <div class="column is-half">
          <b-field label="Logo" custom-class="has-text-grey-light" class="glass-field">
            <div class="upload-wrapper is-flex is-align-items-center">
              <b-upload v-model="imagenArchivo" accept="image/*" @input="subirLogo" class="mr-3">
                <a class="button glass-upload-btn is-rounded">
                  <b-icon icon="upload" size="is-small" class="mr-1" />
                  <span>{{ restaurante.logo ? 'Cambiar' : 'Subir' }}</span>
                </a>
              </b-upload>
              <figure v-if="restaurante.logo" class="image is-48x48 shadow-soft animate__animated animate__fadeIn">
                <img :src="restaurante.logo" class="is-rounded" style="object-fit: cover; height: 48px;" />
              </figure>
              <b-loading :is-full-page="false" :active.sync="subiendo" />
            </div>
          </b-field>
        </div>

        <div class="column is-half">
          <b-field label="Dirección Principal" custom-class="has-text-grey-light" class="glass-field">
            <b-input v-model="restaurante.direccion" placeholder="Calle, número..." class="is-rounded" />
          </b-field>
        </div>

        <div class="column is-half">
          <b-field label="Dirección Secundaria" custom-class="has-text-grey-light" class="glass-field">
            <b-input v-model="restaurante.direccion2" placeholder="Barrio, plaza..." class="is-rounded" />
          </b-field>
        </div>

        <div class="column is-one-quarter">
          <b-field label="Ciudad 1" custom-class="has-text-grey-light" class="glass-field">
            <b-input v-model="restaurante.ciudad" class="is-rounded" />
          </b-field>
        </div>

        <div class="column is-one-quarter">
          <b-field label="Ciudad 2" custom-class="has-text-grey-light" class="glass-field">
            <b-input v-model="restaurante.ciudad2" class="is-rounded" />
          </b-field>
        </div>

        <div class="column is-quarter">
          <b-field label="Teléfono 1" custom-class="has-text-grey-light" class="glass-field">
            <b-input v-model="restaurante.telefono" class="is-rounded" />
          </b-field>
        </div>

        <div class="column is-quarter">
          <b-field label="Teléfono 2" custom-class="has-text-grey-light" class="glass-field">
            <b-input v-model="restaurante.telefono2" class="is-rounded" />
          </b-field>
        </div>

        <div class="column is-half">
          <b-field label="Facebook" custom-class="has-text-grey-light" class="glass-field">
            <b-input v-model="restaurante.facebook" placeholder="URL perfil..." icon="facebook" class="is-rounded" />
          </b-field>
        </div>

        <div class="column is-half">
          <b-field label="Instagram" custom-class="has-text-grey-light" class="glass-field">
            <b-input v-model="restaurante.instagram" placeholder="@usuario..." icon="instagram" class="is-rounded" />
          </b-field>
        </div>

        <div class="column is-full">
          <b-field label="Estado del Restaurante" custom-class="has-text-grey-light" class="glass-field">
            <div class="is-flex is-align-items-center mt-2">
              <b-switch v-model="restaurante.activo" type="is-success" passive-type="is-danger">
                {{ restaurante.activo ? 'Participante Activo' : 'Inactivo / Fuera' }}
              </b-switch>
            </div>
          </b-field>
        </div>

        <div class="column is-full mt-4">
          <hr class="glass-divider" />
          <h3 class="title is-4 has-text-white mb-2">
            <b-icon icon="food" class="mr-2"></b-icon> Producto Participante
          </h3>
          <p class="subtitle is-6 has-text-grey-light mb-4">Crea o edita el producto que ofrecerá este restaurante</p>
        </div>

        <div class="column is-half">
          <b-field label="Nombre del Producto" custom-class="has-text-grey-light" class="glass-field">
            <b-input v-model="restaurante.producto_vinculado.nombre" placeholder="Ej: Burger Especial" class="is-rounded" />
          </b-field>
        </div>

        <div class="column is-half">
          <!-- Espacio reservado o campo extra -->
        </div>

        <div class="column is-full">
          <b-field label="Descripción del Producto" custom-class="has-text-grey-light" class="glass-field">
            <b-input type="textarea" v-model="restaurante.producto_vinculado.descripcion" placeholder="Detalles del producto, ingredientes..." class="glass-textarea" />
          </b-field>
        </div>
        
        <div class="column is-half">
          <b-field label="Estado del Producto" custom-class="has-text-grey-light" class="glass-field">
            <div class="is-flex is-align-items-center mt-2">
              <b-switch v-model="restaurante.producto_vinculado.activo" type="is-success" passive-type="is-danger">
                {{ restaurante.producto_vinculado.activo ? 'Publicado' : 'Borrador' }}
              </b-switch>
            </div>
          </b-field>
        </div>

        <div class="column is-full">
          <b-field label="Galería de Fotos del Producto" custom-class="has-text-grey-light" class="glass-field">
            <b-upload v-model="imagenesArchivosProd" multiple drag-drop accept="image/*" @input="subirFotosProd" class="glass-upload">
              <section class="section has-text-centered py-4">
                <b-icon icon="cloud-upload" size="is-large" class="has-text-primary" />
                <p class="has-text-white mt-1">Arrastra fotos del producto aquí</p>
              </section>
            </b-upload>
          </b-field>
          <div v-if="subiendoProd" class="has-text-centered py-2">
            <b-loading :is-full-page="false" :active.sync="subiendoProd" />
            <span class="has-text-info is-size-7">Subiendo imágenes...</span>
          </div>
          <div class="columns is-multiline mt-3">
            <div v-for="(foto, index) in fotosProd" :key="index" class="column is-3 animate__animated animate__zoomIn">
              <div class="photo-preview shadow-soft">
                <img :src="foto" alt="preview" />
                <button class="delete is-small remove-photo" @click.prevent="eliminarFotoProd(index)"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot glass-footer is-justify-content-center">
      <b-button type="is-primary" icon-left="content-save" class="is-rounded is-medium glass-btn px-6" @click.prevent="registrar">
        {{ restaurante.id ? 'Guardar Cambios' : 'Registrar Restaurante' }}
      </b-button>
    </footer>
  </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService';
import Swal from 'sweetalert2';

export default {
  name: 'FormRestaurante',
  props: {
    restauranteProp: { type: Object, default: null },
    idEventoProp: { type: [Number, String], default: null }
  },
  data() {
    return {
      restaurante: {
        nombre: '', logo: '', direccion: '', direccion2: '', ciudad: '', ciudad2: '',
        telefono: '', telefono2: '', facebook: '', instagram: '', activo: true, id: null,
        evento_id: null,
        producto_vinculado: {
          nombre: '',
          descripcion: '',
          activo: true,
          evento_id: null,
          id: null
        }
      },
      imagenArchivo: null,
      subiendo: false,
      eventos: [],
      imagenesArchivosProd: [],
      fotosProd: [],
      subiendoProd: false
    }
  },
  mounted() {
    HttpService.registrar('eventos.php', { accion: 'obtener' }).then(res => { this.eventos = res || []; });
    
    if (this.restauranteProp) {
      Object.assign(this.restaurante, this.restauranteProp);
      this.restaurante.activo = !!Number(this.restaurante.activo);
      
      if (this.restauranteProp.producto_vinculado) {
        this.restaurante.producto_vinculado = { ...this.restauranteProp.producto_vinculado };
        this.restaurante.producto_vinculado.activo = !!Number(this.restaurante.producto_vinculado.activo);
        this.fotosProd = Array.isArray(this.restauranteProp.producto_vinculado.fotos) ? [...this.restauranteProp.producto_vinculado.fotos] : [];
        // Sincronizar evento_id si el restaurante no lo tiene pero el producto sí
        if (!this.restaurante.evento_id && this.restaurante.producto_vinculado.evento_id) {
          this.restaurante.evento_id = this.restaurante.producto_vinculado.evento_id;
        }
      } else {
        this.restaurante.producto_vinculado = { nombre: '', descripcion: '', activo: true, evento_id: null, id: null };
        this.fotosProd = [];
      }
    }
    
    // Fallback de seguridad: si no hay evento_id después de cargar los datos, 
    // usar el del contexto actual (filtro de la tabla)
    if (!this.restaurante.evento_id && this.idEventoProp) {
      this.restaurante.evento_id = this.idEventoProp;
      if (this.restaurante.producto_vinculado) {
        this.restaurante.producto_vinculado.evento_id = this.idEventoProp;
      }
    }
  },
  methods: {
    async subirLogo(file) {
      if (!file) return;
      const formData = new FormData();
      formData.append('image', file);
      this.subiendo = true;
      try {
        const res = await HttpService.subirArchivo('subir_imagen.php', formData);
        if (res.success) {
          this.restaurante.logo = res.path;
          Swal.fire({ icon: 'success', title: 'Logo Subido', toast: true, position: 'top-end', timer: 2000, showConfirmButton: false });
        }
      } catch (e) {
        console.error('Error al subir logo', e);
      } finally {
        this.subiendo = false;
      }
    },
    async subirFotosProd(files) {
      if (!files || files.length === 0) return;
      this.subiendoProd = true;
      for (let file of files) {
        const formData = new FormData();
        formData.append('image', file);
        try {
          const res = await HttpService.subirArchivo('subir_imagen.php', formData);
          if (res.success) this.fotosProd.push(res.path);
        } catch (e) {
          console.error('Error al subir', e);
        }
      }
      this.subiendoProd = false;
    },
    eliminarFotoProd(index) {
      this.fotosProd.splice(index, 1);
    },
    registrar() {
      if (!this.restaurante.nombre) {
        return Swal.fire('Error', 'El nombre es obligatorio', 'error');
      }
      const rest = { ...this.restaurante };
      
      // Adjuntar las fotos al producto si el producto tiene nombre
      if (rest.producto_vinculado && rest.producto_vinculado.nombre) {
         rest.producto_vinculado.fotos = this.fotosProd.map((url, i) => ({ url, posicion: i + 1 }));
      } else {
         rest.producto_vinculado = null; // No submit if name is empty
      }
      
      this.$emit('registrar', rest);
    }
  }
}
</script>

<style scoped>
.glass-modal {
  background: rgba(43, 43, 43, 0.85) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px !important;
  overflow: hidden;
}

.glass-header {
  background: rgba(255, 255, 255, 0.05) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-body {
  background: transparent !important;
  padding: 30px !important;
}

.glass-footer {
  background: rgba(255, 255, 255, 0.05) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
  padding: 20px !important;
}

.glass-field /deep/ .input {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  transition: all 0.3s;
}

.glass-field /deep/ .input:focus {
  background: rgba(255, 255, 255, 0.12);
  border-color: #00d1b2;
  box-shadow: 0 0 10px rgba(0, 209, 178, 0.2);
}

.glass-upload-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: white !important;
}

.glass-upload-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
}

.glass-btn {
  background: linear-gradient(135deg, #00d1b2 0%, #009e86 100%);
  border: none;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(0, 209, 178, 0.3);
}

.glass-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 209, 178, 0.4);
}

.shadow-soft {
  box-shadow: 0 4px 10px rgba(0,0,0,0.3);
}

::-webkit-scrollbar { width: 6px; }
::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.2); border-radius: 10px; }
</style>

